import { AccountAssetAllocation, AssetAllocationCategory } from '@/cip/_openapi/portfolio-optimizer';
import type { AssetAllocationSegmentKey } from 'views/household/asset-allocation-presentation';
import type { AssetAllocation } from 'views/household/holdings';

const categoryBuckets: Record<AssetAllocationCategory, AssetAllocationSegmentKey> = {
    [AssetAllocationCategory.NET_US_EQUITY_RATIO]: 'equities',
    [AssetAllocationCategory.NET_NON_US_EQUITY_RATIO]: 'equities',
    [AssetAllocationCategory.NET_US_BOND_RATIO]: 'bonds',
    [AssetAllocationCategory.NET_NON_US_BOND_RATIO]: 'bonds',
    [AssetAllocationCategory.NET_CASH_RATIO]: 'cash',
    [AssetAllocationCategory.NET_OTHER_RATIO]: 'other',
    [AssetAllocationCategory.UNCATEGORIZED]: 'other',
};

// Chart exposures are dollar amounts, not the ratios implied by the category names.
export const getCurrentAllocation = (exposures: AccountAssetAllocation[]): AssetAllocation => {
    const amounts: Record<AssetAllocationSegmentKey, number> = { equities: 0, bonds: 0, cash: 0, other: 0 };
    for (const { category, exposure } of exposures) {
        amounts[categoryBuckets[category]] += exposure ?? 0;
    }
    const segments = [
        { key: 'equities' as const, label: 'Equities', amount: amounts.equities },
        { key: 'bonds' as const, label: 'Bonds', amount: amounts.bonds },
        { key: 'cash' as const, label: 'Cash', amount: amounts.cash },
        { key: 'other' as const, label: 'Other', amount: amounts.other },
    ].filter((segment) => segment.amount > 0);
    return { total: segments.reduce((sum, segment) => sum + segment.amount, 0), segments };
};
